import { api } from "../../lib";

export interface IcdCode {
  id: string;
  code: string;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIcdCodeInput {
  code: string;
  description: string;
  isActive?: boolean;
}

export interface UpdateIcdCodeInput extends Partial<CreateIcdCodeInput> {
  id: string;
}

export const icdCodesService = {
  getAll: async () => {
    return api.get<IcdCode[]>("/admin/icd-codes");
  },

  getById: async (id: string) => {
    return api.get<IcdCode>(`/admin/icd-codes/${id}`);
  },

  create: async (input: CreateIcdCodeInput) => {
    return api.post<IcdCode>("/admin/icd-codes", {
      code: input.code,
      description: input.description,
      isActive: input.isActive ?? true,
    });
  },

  update: async (input: UpdateIcdCodeInput) => {
    const { id, ...updates } = input;
    return api.put<IcdCode>(`/admin/icd-codes/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/icd-codes/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<IcdCode>(`/admin/icd-codes/${id}`, {
      isActive,
    });
  },
};
